module.exports = __webpack_public_path__ + "img/svg/prizes.9037d4b0d61b274177289c8efd8c5a29.svg";